module.exports = __webpack_public_path__ + "assets/img/facebook.6b1af9e8.png";